import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap, mergeMap } from 'rxjs/operators';
import * as notifications from '@webapp/sdk/notifications';
import { Actions } from '../../actions';
import {
  ListNotifications,
  ListNotificationsSuccess,
  ListNotificationsError,
  AllNotificationsLoaded,
} from '../action-creators';
import { LIST_NOTIFICATIONS } from '../actions';

export const listNotificationsEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, ListNotifications>(LIST_NOTIFICATIONS),
    mergeMap(async (action) => {
      try {
        const notificationsList = await notifications.list(action.nextToken);

        const actions: Actions[] = [
          new ListNotificationsSuccess(notificationsList.items),
        ];

        if (notificationsList.nextToken) {
          actions.push(new ListNotifications(notificationsList.nextToken));
        }
        if (!notificationsList.nextToken) {
          actions.push(new AllNotificationsLoaded());
        }

        return actions;
      } catch (err) {
        return [new ListNotificationsError(err.message)];
      }
    }),
    concatMap((actions) => actions)
  );
